import { Box, Flex } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';
import { formatTableServices, sortTableDataByService } from '@Utils/table';

import Percent from '@Dashboard/Charts/Percent';
import TableTemplate from '@Dashboard/Charts/TableTemplate';
import DashboardCard from '@Dashboard/Layout/DashboardCard';
import { ServiceTimeRangeCount } from '@Dashboard/Charts/ServiceTimeRangeCount';

function SummaryScanned(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '25%', grow: 2, align: 'left', tooltip: true },
    { width: '25%', grow: 1, align: 'right' },
    { width: '25%', grow: 1, align: 'right' },
    { width: '14%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.service'),
    t(`dashboard.chart.column.last${props.day}`),
    t(`dashboard.chart.column.prev${props.day}`),
    t('dashboard.chart.column.change'),
  ];

  const rawData = formatTableServices(
    props.data?.summaryTotalItemsScanned?.[props.day],
    props.data?.summaryTotalItemsScannedPrevious?.[props.day],
    servicesModel.services
  );
  const data = sortTableDataByService(rawData).map((row) => [
    t(`common.service.${row[0]}`),
    ...row.slice(1, -1),
    <Percent n={row[row.length - 1]} />,
  ]);

  return (
    <DashboardCard
      column={2}
      height="540px"
      title={t('dashboard.chart.title.totalEmailOrFiles')}
    >
      <Flex>
        <Box width="50%">
          {/* <LineTemplate
            type={LineTemplateType.Service}
            data={props.data?.summaryTotalItemsScanned?.[props.day]}
            height="470px"
          /> */}
          <ServiceTimeRangeCount
            data={props.data?.summaryTotalItemsScanned?.[props.day]}
            interval={props.day}
            height="470px"
          />
        </Box>
        <Box width="16px" />
        <Box width="calc(50% - 16px)">
          <TableTemplate config={config} header={header} data={data} />
        </Box>
      </Flex>
    </DashboardCard>
  );
}

export default React.memo(SummaryScanned);
